export function makeEmptyKid() {
  return {
    id: crypto.randomUUID(),
    name: '',
    grade: '',
    gender: 'male',
    subject: '',
  };
}

export function makeEmptyStudent() {
  return { name: '', grade: '', gender: 'male', subject: '' };
}

export function isPersonComplete(person) {
  if (!person.name.trim()) return false;
  return Boolean(person.grade && person.gender && person.subject);
}

export function isStudentProfileComplete(student) {
  return Boolean(student.grade && student.gender && student.subject);
}